// extracted by mini-css-extract-plugin
export default {"preview":"m8UJlxZ8_R","body":"SNQ2avH99l"};